import { atom } from "recoil";

export const getStatusAdmin = atom({
  key: "getStatusAdmin",
  default: [],
});

export const getVersionAdmin = atom({
  key: "getVersionAdmin",
  default: [],
});

export const getDivision = atom({
  key: "getDivision",
  default: [],
});

export const getMasterKotaAtoms = atom({
  key: "getMasterKota",
  default: [],
});

export const getMasterLokasiInterviewAtom = atom({
  key: "getMasterLokasiInterview",
  default: [],
});

export const getMasterClinicAtoms = atom({
  key: "getMasterClinic",
  default: [],
});

export const getMasterInterviewLocationAtoms = atom({
  key: "getMasterIntvLocation",
  default: [],
});

export const getMasterOpportunityAdmin = atom({
  key: "getMasterOpportunityAdmin",
  default: []
})

export const getActiveLandingPage = atom({
  key: "getActiveLandingPage",
  default: []
})

export const getLandingPageAdmin = atom({
  key: "getLandingPageAdmin",
  default: []
})

